import ApplicationsAccordion from 'components/ApplicationsAccordion';
import DetailsViewCardHeader from 'components/DetailsViewCardHeader';
import DetailsViewEntityMenu from 'components/DetailsViewEntityMenu';
import DetailsViewPageContainer from 'components/DetailsViewPageContainer';
import LinkedEntitiesAccordion from 'components/LinkedEntitiesAccordion';
import SourceBadge from 'components/SourceBadge';
import UpdateFieldForm from 'components/forms/UpdateFieldForm';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { CARD_HEADER_DETAIL_TYPE, DETAIL_TYPE_BOUNDARY, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const FieldDetailsPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const {
        applications,
        boundaryMenuItems,
        currentField,
        dropdownMenuItems,
        entitiesLink,
        handleBoundaryNext,
        handleClose,
        handleEditClose,
        handleSelectApplication,
        handleToggleApplications,
        handleToggleLinkedEntities,
        isApplicationsLoading,
        isApplicationsOpen,
        isBoundariesLoading,
        isClosing,
        isEditing,
        isLinkedEntitiesOpen,
        isLoading,
        selectedApplicationId,
        selectedBoundaryGeometry,
        setIsClosing,
        totalBoundariesCount
    } = useData();

    const { APPLICATIONS, LINKED_ENTITIES } = useTranslation();

    return (
        <DetailsViewPageContainer
            geometry={selectedBoundaryGeometry}
            handleClose={handleClose}
            testId={testId}>
            <DetailsViewCardHeader
                detailType={CARD_HEADER_DETAIL_TYPE}
                isLoading={isLoading}
                items={dropdownMenuItems}
                name={currentField?.name ?? ''}
            />

            <SourceBadge name={currentField?.name ?? ''} />

            {isEditing ? (
                <UpdateFieldForm
                    formValues={currentField}
                    isClosing={isClosing}
                    onClose={handleEditClose}
                    setIsClosing={setIsClosing}
                />
            ) : (
                <>
                    <LinkedEntitiesAccordion
                        entitiesLink={entitiesLink}
                        isOpen={isLinkedEntitiesOpen}
                        label={LINKED_ENTITIES}
                        onToggle={handleToggleLinkedEntities}>
                        <DetailsViewEntityMenu
                            entityType={DETAIL_TYPE_BOUNDARY}
                            isLoading={isBoundariesLoading}
                            items={boundaryMenuItems}
                            onNext={handleBoundaryNext}
                            totalCount={totalBoundariesCount}
                        />
                    </LinkedEntitiesAccordion>

                    <ApplicationsAccordion
                        applications={applications}
                        isLoading={isApplicationsLoading}
                        isOpen={isApplicationsOpen}
                        label={APPLICATIONS}
                        onSelectApplication={handleSelectApplication}
                        onToggle={handleToggleApplications}
                        selectedApplicationId={selectedApplicationId}
                    />
                </>
            )}
        </DetailsViewPageContainer>
    );
};

export default FieldDetailsPage;
